import { useDocumentMeta } from '../lib/useDocumentMeta';
import { useForceDarkTheme } from '../theme/useTheme';

export function Logo() {
  // The logo is always shown on the dark theme, whatever the visitor's
  // site-wide preference is; restored on the way out.
  useForceDarkTheme();
  useDocumentMeta({ title: 'Tyler Wrenn' });

  return (
    <main className="logo-stage">
      <h1 className="site-title">Tyler Wrenn</h1>
    </main>
  );
}
